export default __webpack_public_path__ + "static/media/image39.7b8aa5f2.png";